import HARDCODE from '../../business-const/HardCode/HardCode'



const formatoReportList = [
    {
        id: HARDCODE.idFormatoReportApresentacao, 
        descricao: 'Formato Apresentação',
        ordem: 10,
    },
    {
        id: HARDCODE.idFormatoReportImpressao, 
        descricao: 'Formato Impressão (gráficos com valores em destaque)',
        ordem: 20,
    },
]

export default formatoReportList